import { render, staticRenderFns } from "./CommentsWidgetDialog.vue?vue&type=template&id=302ebb7f&scoped=true&"
import script from "./CommentsWidgetDialog.vue?vue&type=script&lang=js&"
export * from "./CommentsWidgetDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommentsWidgetDialog.vue?vue&type=style&index=0&id=302ebb7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ebb7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
